import React from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button
} from '@chakra-ui/react'
import {ArticlesList} from "@/features/Quiz/components/ArticlesList";

type Props = {
    isOpen: boolean;
    onClose: () => void;
    onSelectArticle: (domainId: number, sectionId?: number, title?: string) => void;
    /** Library VIDEO V2 create: mapping-filtered list + sectionId/title on select. */
    libraryV2Select?: boolean;
};

export const ArticlesModal = ({isOpen, onClose, onSelectArticle, libraryV2Select = false}: Props) => {
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            size="4xl"
        >
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Articles</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <ArticlesList onSelectArticle={onSelectArticle} libraryV2Select={libraryV2Select}/>
                </ModalBody>
                <ModalFooter>
                    <Button colorScheme='blue' mr={3} onClick={onClose}>
                        Close
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};
